import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerCatalogIcons } from '@core/icons/icon-registry';

registerCatalogIcons();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
